import ProfileDetails from './ProfileDetails';

const UserSelfGeneralSettings = () => <ProfileDetails />;

export default UserSelfGeneralSettings;
